
;
define("bootstrap.overwrite", ["jquery","bootstrap"], function(){});
